import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import * as moment from 'moment';
import { FormGroup, } from "reactstrap";
import * as routes from "../../../Router/RoutesURL";
import { createNotification } from '../../../Config/NotificationToast';
import redCross from "../../../assets/images/CommonComponent/redCross.svg";
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import Modal from 'react-bootstrap/Modal';
import { stableSort, getComparator, rowOptions} from '../../../utils/Helper'
import { deleteAnnouncement, getAnnouncementList } from '../../../redux/actions/ContentManagementAction/AnnouncementsAction';
import './Announcements.scss';
import { Chip, CircularProgress } from '@mui/material';
import { announcementGuestType, announcementVisibility, tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    {
        id: 'title',
        disablePadding: true,
        label: 'ANNOUNCEMENT TITLE',
    },
    {
        id: 'description',
        disablePadding: false,
        label: 'DESCRIPTION',
        width: '230px'
    },
    {
        id: 'is_redirect_action',
        disablePadding: false,
        label: 'HAS REDIRECTION',
    },
    {
        id: 'visible_to',
        disablePadding: false,
        label: 'VISIBLE TO',
    },
    {
        id: 'visible_program_type',
        disablePadding: false,
        label: 'GUEST TYPE',
    },
    {
      id: 'updation_datetime',
      disablePadding: false,
      label: 'LAST UPDATED/CREATED ON',
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
            {headCells.map((headCell) => (
                <TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                    sx={{minWidth: headCell.width || '130px'}}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id && !headCell.disableSorting}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
            ))}
        </TableRow>
    </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { setShowLoader } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');

    const handleSearch = (event) => {
        setShowLoader(true)
        const newSearchText = event.target.value;
        setSearchText(newSearchText);

        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };


    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            }}
            >
                <div className='col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Announcement List
                    </MainHeading>
                </div>
                <div className='col-8 col-sm-8 col-md-8 col-lg-8 col-xl-9 col-xxl-9 AnnouncementSearchDiv'>

                    <div className="separator"></div>
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={(event) => { handleSearch(event) }}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const AnnouncementTable = (props) => {
    const { activeTab, permission} = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = useState([]);
    const [order, setOrder] = useState(searchParams.get('order_by_type') || 'asc');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [id, setId] = useState();
    const [announcementData, setAnnouncementData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRowData,  setSelectedRowData]= useState(null);
    const navigate = useNavigate()
    const announcementReducer = useSelector(state => state?.announcementReducer);
    const {loading, announcementList, updateLoader} = announcementReducer;
    const dispatch = useDispatch();



    useEffect(()=>{
        if(!loading)
            setShowLoader(false)
        if(!loading && !announcementList && !announcementReducer?.error){
            setShowLoader(true)
        }

    }, [loading])

    useEffect(() => {
      if (activeTab == tabKeys.contentManagement.ANNOUNCEMENT) {
          const sendRequest = {
              "pageNo": searchParams.get('page') || 1,
              "pageSize": searchParams.get('limit') || 10,
              "filter_text": searchParams.get('filter_text') || '',
              "order_by": searchParams.get('order_by') || '',
              "order_by_type": searchParams.get('order_by_type') || 'asc',
          };
          dispatch(getAnnouncementList(sendRequest));
      }else{  
        setOrder('');
        setOrderBy('');
        setRowsPerPage(10)
      }
    }, [activeTab, searchParams, dispatch]);

    useEffect(() => {
      setAnnouncementData(announcementList && announcementList?.data);
    }, [announcementList, announcementReducer])

    
  const handleRequestSort = (event, property) => {
    const isasc = orderBy === property && order === "asc";
    let newOrder = isasc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('order_by', property);
    newParams.set('order_by_type', newOrder);
    newParams.set('page', '1');
    setSearchParams(newParams, { replace: true });
  };


    const handleClick = (name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePageNext = () => {
        setShowLoader(true);
        const nextPage = (announcementList?.current_page || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangePagePrev = () => {
        setShowLoader(true);
        const prevPage = (announcementList?.current_page || 2) - 1;;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true);
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);

        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

  
    const handleNavigateView = (row) => {
        setSelectedRowData(row);
        setShowViewModal(true)
    };

    const handleNavigate = (id,) => {
        if (permission === "write") {
            navigate(routes.EDIT_ANNOUNCEMENT, { state: { id } })
        } else {
            createNotification('warning', "Access Restricted");
        }
    };
    

    const handleDelete = (row) => {
      if (permission === "write") {
        setId(row.id)
        setSelectedRowData(row)
        setShowDeleteModal(true);    
      } else {
          createNotification('warning', "Access Restricted");
      }
    };

    const onDelete = () => {
        const sendRequest = {
            "id": id,
            "doc_path": selectedRowData?.media,
            onSuccessCallback: ()=>{
              if(announcementList?.start === announcementList?.end){
                  const newParams = new URLSearchParams(searchParams);
                  newParams.set("page", (announcementList?.current_page - 1 || 1));
                  setSearchParams(newParams, { replace: true });
              }else{

                  const sendRequest = {
                    "pageNo": announcementList?.current_page || 1,
                    "pageSize": searchParams.get('limit') || 10,
                    "filter_text": searchParams.get('filter_text') || '',
                    "order_by": searchParams.get('order_by') || '',
                    "order_by_type": searchParams.get('order_by_type') || 'asc',
                  };
                  dispatch(getAnnouncementList(sendRequest));
                }
                setShowDeleteModal(false)
            }
        };
        dispatch(deleteAnnouncement(sendRequest));
    }

    return (
      <>
        <Box sx={{ width: '100%' }} className="AnnouncementBox h-100">
        <Paper  className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
          <EnhancedTableToolbar numSelected={selected.length}
            showLoader={showLoader}
            setShowLoader={setShowLoader} activeTab={activeTab} />
          {
            showLoader ?
              <div className='w-100 text-center py-5'>
                <CircularProgress sx={{ 'color': '#74613C' }} />
              </div>
              :
              announcementData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%', overflow: 'scroll' }}>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size='small'
                  stickyHeader
                >
                  <EnhancedTableHead
                    numSelected={selected.length} //This prop is not used in EnhancedTableHead
                    order={order || 'asc'}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={announcementList && announcementData?.length}
                  />
                  <TableBody>
                    {
                      announcementList && stableSort(announcementData, getComparator(order, orderBy))
                        ?.map((row, index) => {
                          const labelId = `enhanced-table-checkbox-${index}`;
                          const dateObj = row?.updation_datetime ? moment(row?.updation_datetime).format('DD/MM/YYYY') : '-';
                          return (
                            <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"
                              tabIndex={-1}
                              key={index}
                            >
                              <TableCell component="th" id={labelId} scope="row" padding="none" onClick={() => { handleNavigateView(row.id) }} sx={{ color: '#000000' }}>
                                {row.title}
                              </TableCell>
                              <TableCell align="left" sx={{ color: '#000000' }}>
                                {row.description}
                              </TableCell>
                              <TableCell align="left" sx={{ minWidth: 200, color: '#000000' }}>
                                {
                                  row.is_redirect_action === 1 ?
                                    'Yes' : 'No'
                                }
                              </TableCell>
                              <TableCell align="left" sx={{ color: '#000000' }}>
                                {
                                  announcementVisibility?.find(item => item.value === row.visible_to)?.label || '-'
                                }
                              </TableCell>
                              <TableCell align="left" sx={{ color: '#000000' }}>
                                {
                                  announcementGuestType?.find(item => item.value === row.visible_program_type)?.label || '-'
                                }
                              </TableCell>

                              <TableCell align="left" sx={{ color: '#000000' }}>{dateObj}</TableCell>
                              <TableCell align="left" className='View' >
                                <div className="d-flex">
                                  <div className={'list-group-item ViewEditClick p-0 '} onClick={() => { handleNavigateView(row) }}>
                                    <i className="fas fa-eye mr-1"></i> View
                                  </div>
                                  <div
                                    className={'list-group-item ViewEditClick p-0 '}
                                    onClick={() => { handleNavigate(row.id) }}><i className="fa fa-pen mr-1"></i> Edit</div>
                                  <div className="list-group-item Delete p-0" onClick={() => { handleDelete(row) }}><img src={Delete} className="mr-1 " alt="Avatar" width="13px" /> <div>Delete</div> </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
              : <div className='text-center w-100 text-muted mt-3'>No Records</div>
              }
            </Paper>
            {
          announcementData
          &&
          <div className='paginationBlock'>
            <div className='textData'><p>Items per page: </p></div>
            <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
              <Select
                placeholder={rowsPerPage}
                className="react-select"
                classNamePrefix="react-select"
                value={rowsPerPage}
                options={rowOptions}
                menuPlacement="top"
                menuPosition="fixed"
                isSearchable={false}
                onChange={handleChangeRowsPerPage}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#F5F5F5',
                    primary: '#74613C',
                  },
                })}
              />
            </FormGroup>
            {announcementList && <p className='endText'>   {announcementList?.start} - {announcementList?.end} of {announcementList?.total}</p>}
            <p>              
              <button className={`btnPrev ${announcementList?.current_page === 1 ? "opacityBtns" : ''}`} disabled={announcementList?.current_page === 1} onClick={() => { handleChangePagePrev() }}>
                  <ArrowBackIosNewSharpIcon className='iconBtn' />
              </button> 
              <button className={`btnPrev ${announcementList?.current_page === announcementList?.total_pages ? "opacityBtns" : ''}`} disabled={announcementList?.current_page === announcementList?.total_pages} onClick={() => { handleChangePageNext() }}>
                  <ArrowForwardIosSharpIcon className='iconBtn' />
              </button></p>
          </div>
        }
            </Box>
            {
              showViewModal &&
              <ViewAnnouncementDetailsModal
                showViewModal={showViewModal}
                setShowViewModal={setShowViewModal}
                data={selectedRowData}
              />
            }
            {
              showDeleteModal &&
              <DeleteModal
              showDeleteModal={showDeleteModal}
              setShowDeleteModal={setShowDeleteModal}
              onDelete={onDelete}
              loading={updateLoader}
              />
            }
        </>
    );
}
export default AnnouncementTable;


const ViewAnnouncementDetailsModal = ({showViewModal, setShowViewModal, data})=>{
  return (
    <Modal  centered className="announcement-modal br-8" show={showViewModal} onHide={() => { setShowViewModal(false) }}>
      <Modal.Header>
          <div className="modalText pb-4">{data.title || '-'}</div>
      </Modal.Header>
      <Modal.Body>
          <div className='w-100 px-3 dataContent'>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Description:</p><p className='othText'>{data.description|| '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Has Redirection:</p><p className='othText'>{data.is_redirect_action===1 ? 'Yes' : 'No'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Redirect Label:</p><p className='othText'>{data.redirect_lable|| '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Redirect page:</p><p className='pre-wrap m-0'>{data.redirect_page|| '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Visible To:</p><p className='othText'>{announcementVisibility?.find(item=> item.value === data.visible_to)?.label || '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Guest Type:</p><p className='othText'>{announcementGuestType?.find(item=> item.value === data.visible_program_type)?.label || '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>Last Updated /Created On:</p><p className='othText'>{data?.updation_datetime ? moment(data?.updation_datetime).format('DD/MM/YYYY') :  '-'}</p></div>
            </div>
            <div className="row mb-1">
              <div className='titleTextData'><p className='headeTitle mb-0'>View Image:</p><p className='othText'>{data.media_url ? <Link target='_blank' to={data.media_url}>{'Click Here'}</Link> : '-'}</p></div>
            </div>
          </div>
      </Modal.Body>
      <Modal.Footer>
          <button type="button" className="btn btn-danger redButton " onClick={()=>setShowViewModal(false)}>
            <img className="mainIcon mr-2" src={redCross} alt="" width="16px" height="16px" />  CLOSE
          </button>
      </Modal.Footer>
  </Modal>
  )
}


const DeleteModal = ({showDeleteModal, setShowDeleteModal, onDelete, loading})=>{
  return (
    <Modal centered className="delete-announcement-modal br-8" show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }}>
      <Modal.Header>
          <div className="modalText pb-4">Are you sure?</div>
      </Modal.Header>
      <Modal.Body>
          <div className="">
              <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
          </div>
      </Modal.Body>
      <Modal.Footer>
          <button type="button" className="btn btn-success greenButton mr-3" onClick={()=>{setShowDeleteModal(false)}}>
              Cancel</button>
          <button type="button" className="btn btn-danger redButton " onClick={onDelete}>
            {
              loading ?
              <CircularProgress sx={{'color': 'red'}} size={30}/>
              :
              'Delete'
            }
          </button>
      </Modal.Footer>
  </Modal>
  )
}